// extracted by mini-css-extract-plugin
module.exports = {"ListDrop":"UserAutocompleteInput_ListDrop__3oFzP","Result":"UserAutocompleteInput_Result__2xfOI"};